<ng-container *ngIf="isInitiated">
  <ng-container *ngIf="isV2Enabled; else v1Template">
    <app-searchbox-v2></app-searchbox-v2>
  </ng-container>
  <ng-template #v1Template>
    <app-searchbox></app-searchbox>
  </ng-template>
</ng-container>
